import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M28.398 15.287c.433.695 2.181 1.526 2.297 2.835l.304.998v1.78c-.773 3.09-3.552 5.003-6.735 4.202-1.418-.357-3.09-1.781-3.532-3.108l.352-.336c3.769-.43 6.104-2.71 6.793-6.415q.48-.259.521.045z",
      fill: "#00833E"
    }, null, -1),
    _createElementVNode("path", {
      d: "m27.284 13.765.11 1.197a.43.43 0 0 1-.332.228c-1.803-.79-3.454-.398-5.194.237l-.164-.456c.182-2.832-1.833-3.397-4.193-3.601-2.127-.184-7.98-.396-9.684.744-2.056 1.374-1.456 4.18.759 5.06 1.942.772 8.132.62 10.3.231 1.579-.556 1.44-.056 1.026 1.319-.193.903-.127 1.838.141 2.721l-.163.397c-3.629.582-11.09.601-14.467-.797C-.44 18.62-.477 10.351 5.332 7.9c3.756-1.586 14.336-1.62 18.01.157 2.68 1.295 3.34 2.992 3.94 5.71z",
      fill: "#00823E"
    }, null, -1)
  ])))
}
export default { render: render }